// extracted by mini-css-extract-plugin
export default {"container":"BookBlock_container__Y10eg","title":"BookBlock_title__XLYlB"};